import { h, Fragment } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import { Alert, Box, Button, Chip, Paper, Stack, Table, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import Localisation3 from "../Common/Localisation3";

import { makeStyles } from "@mui/styles";
import { AppContext } from "../../AppContext";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import palette from "../../theme/palette";
import HomeIcon from '@mui/icons-material/Home';


const useStyles = makeStyles((theme) => ({}));
export default function BiensDuDeal(props) {
	const classes = useStyles();
	const [state, setState] = useState();
	const handleChange = (event) => {
		setState({ ...state, [event.target.name]: event.target.value });
	};
	const app = useContext(AppContext);
	const handleChangeLoc = (loc) => {
		//console.log(loc.center[0], loc.center[1]);
		setState({ ...state, loc: loc, has_loc: true, full_adr: loc.Label });
	};

	useEffect(() => {

		setState(props.upperState);
	}, [props]);
	const sendLoc = () => {

		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				loc: state.loc,
				uid: props.upperState.uid,
				addr_line1: state.addr_line1,
				addr_zip_code: state.addr_zip_code,
				addr_city: state.addr_city,
			}),
		};

		fetch("/api/d42ab0ab458e4ff89c6a39c9d1c8f495", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						window.location.href = (props.upperState.mode == "VN" ? "/newdealv/" : "/newdeala/") + res.re + "/1";

						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	if (!state) return;
	console.log("render biens du deal", state, props)
	return (
		<Fragment>
			{/* <DeleteDealRealEstateDialog onClose={handleCloseDeleteDealRealEstateDialog} state={stateDeleteDealRealEstateDialog} /> */}
			<Stack spacing={1} direction="column" justifyContent="space-between" style="min-height: 300px;">
				{state.new_one && (
					<div style="padding-left: 10px; padding-right: 10px;">
						{" "}

						{/* <Localisation3 upperState={state} mode="ADR" /> */}
						<Stack style="height: 100%">
							<Typography variant="h5" sryle="margin-bottom: 10px;">
								Pour commencer la saisie du bien, veuillez renseigner son adresse
							</Typography>
							<Localisation3 upperState={state} mode="ADR" upperSendLoc={handleChangeLoc} />
							<Box display={"flex"} justifyContent="flex-end">
								<Box>
									<Button
										variant="contained"
										onClick={sendLoc}
										style="margin-top: 20px;"
										disabled={!state.loc}
									>
										valider
									</Button>
								</Box>
							</Box>

						</Stack>
					</div>
				)}
				{!state.new_one && props.upperState.assets && props.upperState.assets.length == 0 && (
					<Box
						display="flex"
						alignItems="center"
						justifyContent="center"
						style="margin-bottom: 10px;   margin-top: 100px;"
						flexDirection="column"
					>
						<Box>
							<Typography variant="h6" style="margin-bottom: 10px;">
								Vous n'avez encore défini aucun bien dans votre dossier de vente
							</Typography>
						</Box>
						<Box>
							<Button
								variant="contained"
								onClick={() => {
									setState((state) => ({ ...state, new_one: true }));
								}}
							>
								Ajouter un bien
							</Button>
						</Box>
					</Box>
				)}
				{!state.new_one && props.upperState.assets && props.upperState.assets.length > 0 && (
					<Stack spacing={1}>

						{props.upperState.assets.map((dl) => {
							return (
								<Paper style="margin-bottom: 8px; padding: 10px; background-color: rgb(247, 247, 247);">
									< Box key={dl.uid} display="flex" justifyContent={"space-between"} alignItems="center" >
										<Box onClick={() => {
											state.tunnel === false
												? (window.location.href = "/dre0/" + dl.uid)
												: (window.location.href =
													(props.upperState.mode == "VN" ? "/newdealv/" : "/newdeala/") + dl.uid + "/1");
										}} style="cursor: pointer">
											<Typography variant="h5">{dl.type_name ? dl.type_name : <em>Type non défini</em>}</Typography>
											<Typography variant="body1">{dl.a ? dl.a : <em>Adresse non enregistrée</em>}</Typography>
										</Box>


										<Box onClick={() => {
											state.tunnel === false
												? (window.location.href = "/dre0/" + dl.uid + "/1")
												: (window.location.href =
													(props.upperState.mode == "VN" ? "/newdealv/" : "/newdeala/") + dl.uid + "/1");
										}} style="cursor: pointer">
											<Typography variant="body1">{dl.im ? "★" : null}</Typography>
										</Box>

										<Box>
											{dl.ic && <Chip
												variant="outlined"
												style={{
													color: palette.success.main,
													cursor: "pointer",
													backgroundColor: "#FFFFFF"
												}}
												onClick={() => {
													state.tunnel === false
														? (window.location.href = "/dre0/" + dl.uid + "/1")
														: (window.location.href =
															(props.upperState.mode == "VN" ? "/newdealv/" : "/newdeala/") + dl.uid + "/1");
												}}
												icon={
													<HomeIcon
														style={{
															color: palette.success.main,
														}}
													/>
												}
												label="Descriptif bien complet"

											/>}
											{!dl.ic && <Chip
												variant="outlined"
												style={{
													color: palette.warning.main,
													cursor: "pointer",
													backgroundColor: "#FFFFFF"
												}}
												onClick={() => {
													state.tunnel === false
														? (window.location.href = "/dre0/" + dl.uid + "/1")
														: (window.location.href =
															(props.upperState.mode == "VN" ? "/newdealv/" : "/newdeala/") + dl.uid + "/1");
												}}
												icon={
													<HomeIcon
														style={{
															color: palette.warning.main,
														}}
													/>
												}
												label="Bien incomplet"

											/>}
										</Box>
										<Box >
											<DeleteForeverIcon
												style="cursor: pointer"
												color="primary"
												onClick={
													() => {
														app.refPopUp.current.handleChangeState(
															{ opened: true, type: "025", params: { uid: dl.uid, mode: props.upperState.mode } }
														)

													}}
											/>
										</Box>
									</Box>
									{
										dl.failed.length > 0 && <Box
											display={"flex"}
											justifyContent="space-between"
											style="width: 100%; cursor: pointer;" onClick={() => {
												state.tunnel === false
													? (window.location.href = "/dre0/" + dl.uid + "/1")
													: (window.location.href =
														(props.upperState.mode == "VN" ? "/newdealv/" : "/newdeala/") + dl.uid + "/1");
											}}>

											<Alert severity="warning" style="width: 100%; margin-top: 10px;">
												<Stack spacing={1} justifyContent="center" style="height: 100%" >
													<Typography variant="body1">Attention: il manque les informations suivantes</Typography>
													<Box display={"flex"} flexWrap={true} justifyContent="space-between">
														{dl.failed.map((fld) => { return <Box p={1}><Typography>{fld}</Typography></Box> })}
													</Box>
												</Stack>
											</Alert>

										</Box>
									}
								</Paper>
							);
						})}

					</Stack>
				)
				}
				{
					!state.new_one && props.upperState.assets && props.upperState.assets.length !== 0 && (
						<Box display="flex" alignItems="center" justifyContent="flex-end" style="margin-bottom: 10px; " flexDirection="row">
							<Box p={1}>{state.tunnel && <Typography>Etape suivante </Typography>}</Box>
							<Box>
								{state.tunnel && props.upperState.mode == "VN" && (
									<Button
										variant="contained"
										onClick={() => {
											window.location.href = "/newdealv/" + props.upperState.uid + "/2";
										}}
									>
										Fixer le prix
									</Button>
								)}
								{state.tunnel && props.upperState.mode == "AM" && (
									<Button
										variant="contained"
										onClick={() => {
											window.location.href = "/newdeala/" + props.upperState.uid + "/2";
										}}
									>
										Fixer le prix
									</Button>
								)}
							</Box>
						</Box>
					)
				}
			</Stack >
		</Fragment >
	);
}
